import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const Logout = () => {
  const { logout } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // Board #3959: the page said "logged out" and stopped, with no route onward. Sign out, then
    // go to the sign-in page; the link below covers a slow or failed sign-out.
    let cancelled = false;
    Promise.resolve(logout())
      .catch(() => {})
      .finally(() => { if (!cancelled) navigate('/login', { replace: true }); });
    return () => { cancelled = true; };
  }, [logout, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Logging out...</h1>
        <p className="text-gray-600 mb-4">You have been logged out successfully.</p>
        <Link to="/login" className="text-blue-600 hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
};

export default Logout;
